import { render } from "./SalesOperViewerPage.vue?vue&type=template&id=000b1052&ts=true"
import script from "./SalesOperViewerPage.vue?vue&type=script&lang=ts"
export * from "./SalesOperViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__